import styles from './styles.module.scss';

import { SidebarItemCompare, SidebarItemInner, SidebarItemSeason } from './index.jsx';
import SidebarItemNavigator from './SidebarItemNavigator.jsx';
import { useViewport } from '../../hooks';
import { BreakpointMobileUp } from '../../constants/ui';

const SidebarItemButton = ({
  t,
  title,
  isActive,
  isDisabled,
  isAiEnabled,
  showCompareButton,
  showAddSeasonButton,
  showNavigatorButton,
  isCompareButtonActive,
  isSoilSensor,
  onClickButton,
  onClickCompareButton,
  onClickAddSeason,
  onClickNavigator,
}) => {
  const { widthViewport } = useViewport();

  return (
    <div
      className={`
    ${styles.sidebarItem} 
    ${isActive ? styles.sidebarItemActive : ''} 
    ${isDisabled ? styles.sidebarItemDisabled : ''}
    `}
    >
      <button
        className={`
        ${styles.sidebarItemInner} 
        ${showAddSeasonButton ? styles.sidebarItemInnerExpanded : ''}
        `}
        disabled={isDisabled}
        onClick={onClickButton}
      >
        <SidebarItemInner title={title} isAiEnabled={isAiEnabled} isSoilSensor={isSoilSensor} />
      </button>

      {(showCompareButton || showAddSeasonButton || showNavigatorButton) && (
        <div className={styles.sidebarItemNav}>
          {/*Add season button*/}
          {showAddSeasonButton && (
            <SidebarItemSeason onClickButton={onClickAddSeason} isButtonLarge={widthViewport < BreakpointMobileUp} t={t} />
          )}
          {/*Compare sensor button*/}
          {showCompareButton && (
            <SidebarItemCompare isActive={isCompareButtonActive} onClickButton={onClickCompareButton} isButtonLarge={widthViewport < BreakpointMobileUp} />
          )}
          {/*Find sensor (navigator) button*/}
          {showNavigatorButton && widthViewport < BreakpointMobileUp && <SidebarItemNavigator isButtonLarge={widthViewport < BreakpointMobileUp} onClickButton={onClickNavigator} />}
        </div>
      )}
    </div>
  );
};

export default SidebarItemButton;
